import CloseIcon from '@mui/icons-material/CloseOutlined';
import { Alert, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { toast } from 'react-toastify';

const NotificationToast = (props) => {
    const { severity, message, toastId } = props;

    return (
        <Alert
            severity={severity}
            onClose={() => {
                toast.dismiss(toastId);
            }}
        >
            {message}
        </Alert>
    );
};

NotificationToast.propTypes = {
    severity: PropTypes.string,
    message: PropTypes.string,
    toastId: PropTypes.string,
};
export default NotificationToast;
